import { IconProps } from '../../Types';

export const IconGrowDown = (props: IconProps) => {
    return (
        <svg
            width='13'
            height='12'
            viewBox='0 0 13 12'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            {...props}
        >
            <g clipPath='url(#clip0_3689_31628)'>
                <path
                    d='M11.2002 8.5L7.26588 4.56568C7.06787 4.36768 6.96887 4.26867 6.8547 4.23158C6.75428 4.19895 6.64611 4.19895 6.54569 4.23158C6.43152 4.26867 6.33252 4.36768 6.13451 4.56569L4.76588 5.93432C4.56787 6.13232 4.46887 6.23133 4.3547 6.26842C4.25428 6.30105 4.14611 6.30105 4.04569 6.26842C3.93152 6.23133 3.83252 6.13232 3.63451 5.93431L1.2002 3.5M11.2002 8.5H7.7002M11.2002 8.5V5'
                    stroke='#D92D20'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </g>
            <defs>
                <clipPath id='clip0_3689_31628'>
                    <rect
                        width='12'
                        height='12'
                        fill='white'
                        transform='translate(0.200195)'
                    />
                </clipPath>
            </defs>
        </svg>
    );
};
